import _assign from 'lodash/assign'

let LocalizationFactory = (AppConfig, $location) => {
  'ngInject'

  // expected : https://lu.pp.rlinkstore.com/... to extract "lu"
  let getCountry = () => {
    let host = $location.host()
    let country = 'default'
    if (host.includes('rlinkstore')) {
      country = $location.host().split('.')[0]
    } else {
      country = $location.host().split('-')[2]
    }
    if (!country || (country !== 'default' && country.length !== 2 && country !== 'beta' && country !== 'belux' &&
      country !== 'chat')) {
      country = AppConfig.default.country
    }
    if (country === 'beta') {
      country = 'zz'
    }
    if (country === 'belux') {
      country = 'be'
    }
    if (country === 'chat') {
      country = 'ch'
    }
    return country
  }

  let getLocalizedAppConfig = () => {
    return _assign({}, AppConfig.default, AppConfig[getCountry()])
  }

  return {getCountry, getLocalizedAppConfig}
}

export default LocalizationFactory



// WEBPACK FOOTER //
// ./src/app/common/localization/localization.factory.js